export default __webpack_public_path__ + "95643a997919cdbcbc883d8d4af75145.svg";